import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    content: [],
    UserFeeds: {
      items: [
        {
          id: 'news', name: 'Nachrichten', path: 'news', isUserDefined: false, urls: []
        },
        {
          id: 'sport', name: 'Sport', path: 'sport', isUserDefined: false, urls: []
        },
        {
          id: 'technik', name: 'Technik', path: 'technik', isUserDefined: false, urls: []
        },
        {
          id: 'lifestyle', name: 'Lifestyle', path: 'lifestyle', isUserDefined: false, urls: []
        },
        {
          id: 'wirtschaft', name: 'Wirtschaft', path: 'wirtschaft', isUserDefined: false, urls: []
        },
        {
          id: 'deals', name: 'Deals', path: 'deals', isUserDefined: false, urls: []
        },
      ]
    },
    StaticFeeds: {
      items: [
        {
          id: 'news', name: 'News', path: 'news',
          urls: [
            { id: 1, type: 1, name: 'welt', homepage: 'https://www.welt.de', url: 'https://www.welt.de/feeds/latest.rss' },
            { id: 2, type: 1, name: 'sz', homepage: 'https://www.sueddeutsche.de', url: 'https://rss.sueddeutsche.de/rss/Topthemen' },
            { id: 3, type: 1, name: 'stern', icon: 'https://www.stern.de/favicon.ico', homepage: 'https://www.stern.de', url: 'https://www.stern.de/feed/standard/alle-nachrichten/' },
            { id: 4, type: 1, name: 'web', homepage: 'https://www.web.de', url: 'https://web.de/magazine/index.rss' },
          ]
        },
        {
          id: 'sport', name: 'Sport', path: 'sport', urls: [
            { id: 1, type: 1, name: 'sport bild', homepage: 'https://www.sportbild.de', url: 'https://sportbild.bild.de/rss/vw-alle-artikel/vw-alle-artikel-45028184,sort=1,view=rss2.sport.xml' },
            { id: 2, type: 1, name: 'sport1.de', homepage: 'https://www.sport1.de', url: 'http://www.sport1.de/news.rss' },
            { id: 3, type: 1, name: 'spiegel sport', homepage: 'https://www.spiegel.de/sport', url: 'http://www.spiegel.de/sport/index.rss' },
            { id: 4, type: 1, name: 't-online', homepage: 'https://www.t-online.de', url: 'http://feeds.t-online.de/rss/sport' },
          ]
        },
        {
          id: 'technik', name: 'Technik', path: 'technik', urls: [
            { id: 1, type: 1, name: 'heise', homepage: 'https://www.heise.de', url: 'https://www.heise.de/newsticker/heise-atom.xml' },
            { id: 2, type: 1, name: 'golem', homepage: 'https://www.golem.de', url: 'https://www.golem.de/rss.php?feed=RSS2.0' },
            { id: 3, type: 1, name: 'curved', homepage: 'https://www.curved.de', url: 'https://curved.de/rss' },
            { id: 4, type: 1, name: 'mobiflip', homepage: 'https://www.mobiflip.de', url: 'http://feeds.feedburner.com/mobiflip' },
          ]
        },
        {
          id: 'lifestyle', name: 'Lifestyle', path: 'lifestyle', urls: [
            { id: 1, type: 1, name: 'GQ', homepage: 'https://www.gq-magazin.de', url: 'http://www.gq-magazin.de/feed/gqall/rss' },
            { id: 2, type: 1, name: 'Iconist', homepage: 'https://www.welt.de/icon', url: 'https://www.welt.de/feeds/section/icon.rss' },
            { id: 3, type: 1, name: 'Fit4Fun', homepage: 'https://www.fitforfun.de', url: 'https://www.fitforfun.de/fff/XML/rss_fff_alle_inhalte.xml' },
            { id: 4, type: 1, name: 'Vogue', homepage: 'https://www.vogue.de', url: 'http://www.vogue.de/rss/all/' },
          ]
        },
        {
          id: 'wirtschaft', name: 'Wirtschaft', path: 'wirtschaft', urls: [
            { id: 1, type: 1, name: 'handelsblatt', homepage: 'https://www.handelsblatt.de', url: 'http://www.handelsblatt.com/rss/HB_Boerse.xml' },
            { id: 2, type: 1, name: 'manager-magazin', homepage: 'https://www.manager-magazin.de', url: 'http://www.manager-magazin.de/news/rss/index.xml' },
            { id: 3, type: 1, name: 'aktionaer', homepage: 'https://www.deraktionaer.de', url: 'http://www.deraktionaer.de/aktionaer-news.rss' },
            { id: 4, type: 1, name: 'gruenderszene', homepage: 'https://www.gruenderszene.de', url: 'https://www.gruenderszene.de/feed' },
            // { name: 'handelsblatt1', homepage: 'https://www.handelsblatt.de', url: 'http://www.handelsblatt.com/rss/HB_Boerse.xml' },
            // { name: 'manager-magazin1', homepage: 'https://www.manager-magazin.de', url: 'http://www.manager-magazin.de/news/rss/index.xml' },
            // { name: 'aktionaer1', homepage: 'https://www.deraktionaer.de', url: 'http://www.deraktionaer.de/aktionaer-news.rss' },
            // { name: 'gruenderszene1', homepage: 'https://www.gruenderszene.de', url: 'https://www.gruenderszene.de/feed' },
          ]
        },
        {
          id: 'deals', name: 'Deals', path: 'deals', urls: [
            { id: 1, type: 1, name: 'snipz', homepage: 'https://www.snipz.de', url: 'https://snipz.de/feed' },
            { id: 2, type: 1, name: 'MyDealz', homepage: 'https://www.mydealz.de', url: 'https://www.mydealz.de/rss/hot' },
            { id: 3, type: 1, name: 'mein-deal', homepage: 'https://www.mein-deal.com', url: 'http://www.mein-deal.com/feed/atom/' },
            { id: 4, type: 1, name: 'Urlaubstracker', homepage: 'https://www.urlaubstracker.de', url: 'https://www.urlaubstracker.de/rss/' },
          ]
        },
      ]
    }
  },
  mutations: {
    setUserFeeds(state, aContent) {
      state.UserFeeds = aContent;
    },
    clearContent(state) {
      state.content = [];
    },
    setContentItem(state, aContent) {
      // mutate state
      let existingFeed = state.content.find(function (data) {
        return data.url == aContent.url;
      })

      if (existingFeed === undefined) {
        state.content.push(aContent);
      }
      else {
        existingFeed.nextPageNo = aContent.nextPageNo;
        existingFeed.nextPageGuid = aContent.nextPageGuid;
        existingFeed.feed = existingFeed.feed.concat(aContent.feed);
      }

    },
    addUserFeed(state, newFeed) {
      // TODO Methode erstellen START
      let existingCategory = state.UserFeeds.items.find(function (data) {
        return data.id == newFeed.categoryId;
      });

      if (existingCategory === undefined) {
        existingCategory = { id: newFeed.categoryId, name: newFeed.category, path: newFeed.categoryId, isUserDefined: true, urls: [] };
        state.UserFeeds.items.push(existingCategory);
      }
      // TODO Methode erstellen ENDE

      // TODO homepage url parsen
      let homepage = '';

      let id = 1;
      if (existingCategory.urls.length > 0)
        id = existingCategory.urls[existingCategory.urls.length - 1].id + 1;

      existingCategory.urls.push({ id: id, name: newFeed.name, type: newFeed.type, homepage: homepage, url: newFeed.url });

    },
    editUserFeed(state, editedFeed) {
      let updatedFeed = { id: editedFeed.id, name: editedFeed.name, type: editedFeed.type, homepage: '', url: editedFeed.url };
      let category = state.UserFeeds.items[editedFeed.indexCategory];
      //Gleiche Categoey
      if (category.id == editedFeed.categoryId) {
        category.urls.splice(editedFeed.indexFeed, 1, updatedFeed);
      }
      //Kategorie geändert
      else {

        // TODO deleteUserCategory aufrufen
        category.urls.splice(editedFeed.indexFeed, 1);
        if (category.isUserDefined && category.urls.length == 0) {
          state.UserFeeds.items.splice(editedFeed.indexCategory, 1);
        }

        // TODO Methode erstellen START
        let existingCategory = state.UserFeeds.items.find(function (data) {
          return data.id == editedFeed.categoryId;
        });

        if (existingCategory === undefined) {

          existingCategory = { id: editedFeed.categoryId, name: editedFeed.category, path: editedFeed.categoryId, isUserDefined: true, urls: [] };
          state.UserFeeds.items.push(existingCategory);
        }

        updatedFeed.id = 1;
        if (existingCategory.urls.length > 0)
          updatedFeed.id = existingCategory.urls[existingCategory.urls.length - 1].id + 1;
        // TODO Methode erstellen ENDE

        existingCategory.urls.push(updatedFeed);
      }
    },
    deleteUserFeed(state, deletedFeed) {
      let category = state.UserFeeds.items[deletedFeed.indexCategory];
      category.urls.splice(deletedFeed.indexFeed, 1);
      if (category.isUserDefined && category.urls.length == 0) {
        state.UserFeeds.items.splice(deletedFeed.indexCategory, 1);
      }
    },
  },
  actions: {
    addUserFeed({ commit, dispatch }, newFeed) {
      return new Promise(resolve => {
        commit('addUserFeed', newFeed)
        dispatch('saveUserFeeds')
        resolve();
      });
    },
    editUserFeed({ commit, dispatch }, editedFeed) {
      return new Promise(resolve => {
        commit('editUserFeed', editedFeed)
        dispatch('saveUserFeeds')
        resolve();
      });
    },
    deleteUserFeed({ commit, dispatch }, deletedFeed) {
      return new Promise(resolve => {
        commit('deleteUserFeed', deletedFeed);
        dispatch('saveUserFeeds');
        resolve();
      });

    },
    saveUserFeeds({ state }) {
      localStorage.setItem('UserFeeds', JSON.stringify(state.UserFeeds))
    },
    loadUserFeeds({ state, commit }) {
      let userFeeds = state.UserFeeds;
      if (window.localStorage.getItem('UserFeeds')) {
        userFeeds = JSON.parse(window.localStorage.getItem('UserFeeds'));
      }
      //state.UserFeeds = userFeeds;
      commit('setUserFeeds', userFeeds);
    },
    async setContent(context, aContent) {
      await context.commit('setContentItem', aContent);
    },
    clearContent(context) {
      context.commit('clearContent');
    }

  }
})
